export default "__VITE_ASSET__7833d014__"